import { useEffect, useRef } from 'react';

function Video({animate, ...props}) {
   const vidref = useRef(null);
   const video= props.src;
const poster = props.poster ? props.poster : '';
   const loop = props.loop && animate ? true : false;

   useEffect(() => {
      if(animate) {
         vidref.current.currentTime = 0;
         vidref.current.play();
      } else { 
         vidref.current.onloadedmetadata = () => {
            vidref.current.currentTime = vidref.current.duration;
            vidref.current.pause();
         }
         if (typeof vidref.current.duration !== null) {
            vidref.current.currentTime = 100;
            vidref.current.pause();
         }
      }
   }, [animate])

   return (
     <div className={`video ${props.name}`}>
         <video autoplay loop={loop} webkit-playsinline playsInline muted ref={vidref} poster={poster} class="i2">
            <source src={video} type="video/mp4" />
         </video>
     </div>
   );
 }
 
 export default Video;